// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__MOAS7","ranges":"BmiRanges_ranges__12Uon"};